const writeTrackLog = (str) => {
    console.log(str);
    if (!window.trackingLogObj) return;
    var log = str + " [" + (new Date()) + "]\n";


    window.trackingLogObj.createWriter(function (fileWriter) {
        fileWriter.seek(fileWriter.length);

        var blob = new Blob([log], {type: 'text/plain'});
        fileWriter.write(blob);
    }, function (data) {
        console.log('FAILED TO WRITE TRACKING LOG', data)
    });
};

export {writeTrackLog}
